import React, { lazy, memo } from 'react';
const RecipeShowcase = memo(() => {
  const handlePurchaseClick = () => {
    if (window.fbq) window.fbq('track', 'AddToCart', {
      content_name: '7 Cenas Latinas en 30 Minutos',
      content_type: 'product',
      value: 7.0,
      currency: 'USD'
    });
  };
  return <section className="py-16 bg-white" data-id="element-263">
      <div className="container mx-auto px-4" data-id="element-264">
        <div className="text-center mb-12" data-id="element-265">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-gray-800" data-id="element-266">
            ¡Mira las deliciosas recetas que podrás preparar!
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-267">
            Estas son solo algunas de las 7 cenas latinas que aprenderás a
            preparar en solo 30 minutos
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-268">
          <div className="rounded-lg overflow-hidden shadow-lg" data-id="element-269">
            <div className="img-container aspect-ratio-16-9" data-id="element-270">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wE5dgk2e5aaY5eyZVvgjU1/Recetas_1.jpg" alt="Variedad de recetas latinas: tacos, arroz, frijoles y más" className="img-content" width="600" height="338" loading="lazy" decoding="async" onError={e => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = 'https://via.placeholder.com/600x338/f5f5f5/a97142?text=Recetas+Latinas';
            }} data-id="element-271" />
            </div>
            <div className="p-4 bg-amber-50" data-id="element-272">
              <h3 className="font-bold text-lg text-custom-brown mb-2" data-id="element-273">
                Recetas tradicionales con un toque exprés
              </h3>
              <p className="text-gray-700" data-id="element-274">
                Desde tacos y frijoles hasta pastas y sopas - todas listas en 30
                minutos o menos.
              </p>
            </div>
          </div>
          <div className="rounded-lg overflow-hidden shadow-lg" data-id="element-275">
            <div className="img-container aspect-ratio-16-9" data-id="element-276">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jMgTufWYJSPMqragXWvSL1/Recetas_2.jpg" alt="Más recetas latinas: quesadillas, sopa, pollo y ensaladas" className="img-content" width="600" height="338" loading="lazy" decoding="async" onError={e => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = 'https://via.placeholder.com/600x338/f5f5f5/a97142?text=Más+Recetas';
            }} data-id="element-277" />
            </div>
            <div className="p-4 bg-amber-50" data-id="element-278">
              <h3 className="font-bold text-lg text-custom-brown mb-2" data-id="element-279">
                Variedad y nutrición en cada plato
              </h3>
              <p className="text-gray-700" data-id="element-280">
                Comidas balanceadas y deliciosas que toda tu familia disfrutará.
              </p>
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-281">
          <div className="flex flex-col sm:flex-row items-center justify-center" data-id="element-282">
            <a href="https://pay.hotmart.com/W101891326K?checkoutMode=10" className="bg-custom-brown text-white hover:bg-custom-brown-dark font-bold py-4 px-10 rounded-lg text-xl transition duration-300 shadow-lg" onClick={handlePurchaseClick} data-id="element-283">
              ¡Quiero cocinar estas recetas ahora! - $7.00
            </a>
          </div>
          <p className="mt-3 text-custom-brown font-medium" data-id="element-284">
            <del className="text-gray-500" data-id="element-285">$83</del> - ahorras $77
          </p>
        </div>
      </div>
    </section>;
});
export default RecipeShowcase;